import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "flex justify-center" }
const _hoisted_2 = {
  key: 0,
  xmlns: "http://www.w3.org/2000/svg",
  class: "h-5 w-5",
  fill: "none",
  viewBox: "0 0 24 24",
  stroke: "currentColor"
}
const _hoisted_3 = /*#__PURE__*/_createElementVNode("path", {
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  d: "M12 3v1m0 16v1m9-9h-1M4 12H3m15.364 6.364l-.707-.707M6.343 6.343l-.707-.707m12.728 0l-.707.707M6.343 17.657l-.707.707M16 12a4 4 0 11-8 0 4 4 0 018 0z"
}, null, -1)
const _hoisted_4 = [
  _hoisted_3
]
const _hoisted_5 = {
  key: 1,
  xmlns: "http://www.w3.org/2000/svg",
  class: "h-5 w-5",
  fill: "none",
  viewBox: "0 0 24 24",
  stroke: "currentColor"
}
const _hoisted_6 = /*#__PURE__*/_createElementVNode("path", {
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  d: "M20.354 15.354A9 9 0 018.646 3.646 9.003 9.003 0 0012 21a9.003 9.003 0 008.354-5.646z"
}, null, -1)
const _hoisted_7 = [
  _hoisted_6
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("button", {
      class: _normalizeClass(["rounded-full h-8 w-8 m-2 flex justify-center items-center shadow-xl", 
        !_ctx.store.dark
          ? 'bg-gray-500 shadow-gray-700 border-white/20 hover:bg-gray-600 text-white'
          : 'bg-white-600 hover:bg-gray-200 border-black/20 text-white hover:text-gray-600'
      ]),
      onClick: _cache[0] || (_cache[0] = ($event: any) => (
        [
          _ctx.store.switchDark(),
          _ctx.store.primaryColor.includes('white') && !_ctx.store.dark
            ? _ctx.store.setPrimaryColor(
                _ctx.store.primaryColor.replace('white', 'black')
              )
            : '',
          _ctx.store.primaryColor.includes('black') && _ctx.store.dark
            ? _ctx.store.setPrimaryColor(
                _ctx.store.primaryColor.replace('black', 'white')
              )
            : '',
        ]
      ))
    }, [
      (_ctx.store.dark)
        ? (_openBlock(), _createElementBlock("svg", _hoisted_2, _hoisted_4))
        : (_openBlock(), _createElementBlock("svg", _hoisted_5, _hoisted_7))
    ], 2)
  ]))
}